<header>
  <h1>Long range brilliance</h1>
  <p>
    Minutes played and 3-point field goals made in the regular season by the
    best 3-point shooters in NBA history
  </p>
</header>

<style>
  header {
    margin-top: 10px;
    margin-bottom: 10px;
    max-width: 600px;
  }

  h1 {
    font-family: 'Merriweather';
    font-size: 22px;
    line-height: 30px;
  }
</style>
